<div class="container">
  <!-- section title -->
  <h2 class="section-title wow fadeIn">Pricing Plans</h2>

  <div class="spacer-60"></div>

  <div class="row">
    <div class="col-md-4 pr-md-0 mt-md-4 mt-0">
      <!-- price item -->
      <div class="price-item bg-white rounded shadow-dark text-center">
        <img src="assets/images/price-1.svg" alt="Regular" />
        <h2 class="plan">Basic</h2>
        <p>UX Designs</p>
        <p>UI Design Prototype, UX research and Design, portfolio</p>
        <h3 class="price"><span>from </span><em>$</em>500</h3>
        <a href="javascript:" class="btn btn-default">Contact</a>
      </div>
    </div>

    <div class="col-md-4 px-md-0 my-4 my-md-0">
      <!-- price item recommended-->
      <div class="price-item bg-white rounded shadow-dark text-center best">
       
        <img src="assets/images/price-2.svg" alt="Premium" />
        <h2 class="plan">Frontend</h2>
        <p>UI Design Prototype, UX research and Design, portfolio, full front-end development api intergration ready</p>
        <p></p>
        <h3 class="price"><span>from </span><em>$</em>800</h3>
        <a href="javascript:" class="btn btn-default">Contact</a>
      </div>
    </div>

    <div class="col-md-4 pl-md-0 mt-md-4 mt-0">
      <!-- price item -->
      <div class="price-item bg-white rounded shadow-dark text-center">
        <span class="badge">Recommended</span>
        <img src="assets/images/price-3.svg" alt="Ultimate" />
        <h2 class="plan">Full-stack Sytems</h2>
        <p>UI Design Prototype, UX research and Design, portfolio, full front-end development, api intergrations, email support</p>
        <p></p>
        <h3 class="price"><span>from </span><em>$</em>1000</h3>
        <a href="javascript:" class="btn btn-default">Contact</a>
      </div>
    </div>
  </div>
</div>
